import React, { Component, Fragment } from 'react';
import './form.css'
import EmaptaWorkspace from '../workspaces/emapta-ph.workspace';
import SelectWorkspace from '../workspaces/select.workspace';
import ThirdParty from '../workspaces/3rd-party.workspace';
import InactiveEmapta from '../workspaces/inactive-emapta.workspace';
import Grievances from '../workspaces/grievances.workspace';
import { Modal, Button } from 'react-bootstrap';
import axios from 'axios';

class HelpMeForm extends Component {

	state = {
		page: {
			loaded: false,
			hasError: false,
		},
		categories: null,
		sites: null,
		workspaces: [
			{ workspace_id: 2, workspace_name: 'Active Member of EMAPTA' },
			{ workspace_id: 5, workspace_name: 'Alumni or Former Member of EMAPTA' },
			{ workspace_id: 4, workspace_name: 'Non-EMAPTA Member' },
			{ workspace_id: 6, workspace_name: 'Grievances' },
		],
		selectedWorkspace: null,
		// selectedWorkspace: { workspace_id: 6, workspace_name: 'Grievances' },
		formFields: [],
		modal: {
			loginForm: {
				username: "",
				password: ""
			},
			loginStatus: {
				show: false,
				submitted: false,
				error: null
			},
			formErrors: []
		}
	}

	selectedWorkspaceHandler = (workspace) => {
		let { selectedWorkspace, modal } = this.state;

		if (workspace && workspace.workspace_id === 2) {
			modal.loginStatus.show = true;
			modal.loginStatus.submitted = false;
			modal.formErrors = [];
		} else {
			selectedWorkspace = workspace;
		}

		this.setState({ ...this.state, selectedWorkspace, modal });
	}

	inputHandler = e => {
		let { modal } = this.state;
		modal.loginForm[e.target.name] = e.target.value;

		if (modal.loginStatus.error !== null) modal.loginStatus.error = null;

		if (modal.formErrors.includes(e.target.name)) {
			console.log(modal.formErrors);
			let idx = modal.formErrors.indexOf(e.target.name);
			if (idx >= 0) modal.formErrors.splice(idx, 1);
		}

		this.setState({ ...this.state, modal });
	}

	loginHandler = e => {
		let { modal, selectedWorkspace } = this.state;
		let errors = [];

		if (modal.loginForm.username === "") errors.push("username");
		if (modal.loginForm.password === "") errors.push("password");

		if (errors.length > 0) {
			modal.formErrors = errors;
			this.setState({ ...this.state, modal });
		} else {
			let updateModal = this.state.modal;
			updateModal.loginStatus.submitted = true;
			this.setState({ ...this.state, modal: updateModal });

			axios.post("/api/auth/login", modal.loginForm)
				.then(response => {
					selectedWorkspace = { workspace_id: 2, workspace_name: 'Active Member of EMAPTA' };
					modal.loginStatus.submitted = false;
					modal.loginStatus.show = false;
					this.setState({ ...this.state, selectedWorkspace });
				}).catch(error => {
					modal.loginStatus.error = error.response.data.error;
					modal.formErrors = ["username", "password"];
					modal.loginStatus.submitted = false;

					console.log(error, 'errorerror')
					this.setState({ ...this.state, selectedWorkspace });
				})
		}
	}

	closeLoginModal = () => {
		let { modal } = this.state;

		if (!modal.loginStatus.submitted) {
			modal.loginForm.username = "";
			modal.loginForm.password = "";
			modal.loginStatus.show = false;
			modal.loginStatus.submitted = false;
			modal.formErrors = [];
		}

		this.setState({ ...this.state, modal });
	}

	render() {
		let { selectedWorkspace, modal } = this.state;

		return (
			<div className="content help-form" style={{ background: "#13259A " }}>
				<header>
					<div className="row">
						<div className="col-sm-5 col-xs-12">
							<a href="#">
								<img className="img-fluid" src="images/logo-emapta-single_white.png" width="350" />
							</a>
							<h1 style={{ color: '#ffffff', padding: 0, marginBottom: 0 }}>C.H.E.E.R.</h1>
							<p style={{ margin: 0, padding: 0 }}> Centre for HR Employee Enquiries and Requests</p>
							<hr style={{ marginTop: 40, marginBottom: 30 }} />
							{/* <p>
								Welcome to the Emapta Centre for HR Employee Enquiries and Requests (C.H.E.E.R.) <br />
								We are happy to be of help Mondays through Fridays from 6AM to 12MN Philippines Time. <br />
								Please provide details of your query and our dedicated HR team will reach out to you without delay.
							</p> */}
							{/* <p>
								Cheers, <br />
								Emapta HR Team
							</p> */}
						</div>
					</div>
				</header>

				{/* Main content */}
				<div className='main-content form-content' style={{ minHeight: 800 }}>
					{selectedWorkspace === null && <SelectWorkspace workspaces={this.state.workspaces} selectWorkspace={id => this.selectedWorkspaceHandler(id)} />}
					{selectedWorkspace && selectedWorkspace.workspace_id === 2 && <EmaptaWorkspace />}
					{selectedWorkspace && selectedWorkspace.workspace_id === 5 && <InactiveEmapta />}
					{selectedWorkspace && selectedWorkspace.workspace_id === 4 && <ThirdParty />}
					{selectedWorkspace && selectedWorkspace.workspace_id === 6 && <Grievances />}
				</div>

				<Modal show={modal.loginStatus.show} onHide={this.closeLoginModal}>
					<Modal.Header closeButton>
						<Modal.Title>Empower Login</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className='row'>

							{modal.loginStatus.error !== null ?
								<div className='col-12'>
									<div className='alert alert-danger'>{modal.loginStatus.error}</div>
								</div>

								: null}

							<div className='col-12'>
								<label>Username</label>
								<input
									type="text"
									id="username"
									name="username"
									onChange={e => this.inputHandler(e)}
									value={modal.loginForm.username}
									className={`form-control ${modal.formErrors.includes("username") ? 'is-invalid' : ''}`}
									disabled={modal.loginStatus.submitted}
								/>
							</div>
							<div className='col-12 mt-3'>
								<label>Password</label>
								<input
									type="password"
									id="password"
									name="password"
									onChange={e => this.inputHandler(e)}
									value={modal.loginForm.password}
									className={`form-control ${modal.formErrors.includes("password") ? 'is-invalid' : ''}`}
									disabled={modal.loginStatus.submitted}
								/>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<button
							className='btn btn-primary'
							onClick={e => this.loginHandler(e)}
							disabled={modal.loginStatus.submitted}
						>
							Login
						</button>
					</Modal.Footer>
				</Modal>
			</div >
		)
	}
}

export default HelpMeForm
